const COLORS = ["#14b8c4", "#3b82f6", "#8b5cf6", "#f97316", "#f43f5e", "#22c55e", "#eab308"];

// Same person always gets the same colour.
export const colorFor = (id) => COLORS[Math.abs(Number(id) || 0) % COLORS.length];

/** Mix a #rrggbb colour with white so dark cell text stays readable on it. */
export const tintColor = (hex, amount = 0.6) => {
  const n = parseInt(String(hex).replace("#", ""), 16);
  const mix = (c) => Math.round(c + (255 - c) * amount);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map(mix);
  return `#${[r, g, b].map((c) => c.toString(16).padStart(2, "0")).join("")}`.toUpperCase();
};
